import { render } from "./DataView.vue?vue&type=template&id=4b5c6c04"
import script from "./DataView.vue?vue&type=script&lang=js"
export * from "./DataView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__